import { useEffect, useState } from 'react'
import type { CalendarEvent } from '../types'
import { fetchEvents } from '../lib/api'

/**
 * Loads events from the gateway (→ Payload CMS). Events are sorted by date
 * ascending.
 *
 * There is deliberately no bundled copy of the events to fall back on: shipping
 * one is what previously kept deleted events on the site forever. The calendar
 * shows exactly what the CMS holds, and an empty CMS renders the empty state.
 */
export function useEvents(): { events: CalendarEvent[]; loaded: boolean } {
  const [events, setEvents] = useState<CalendarEvent[]>([])
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    const ctrl = new AbortController()
    fetchEvents(ctrl.signal)
      .then((data) => {
        if (!Array.isArray(data)) return
        const sorted = [...data].sort(
          (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime(),
        )
        setEvents(sorted)
        setLoaded(true)
      })
      .catch(() => {
        /* request failed or aborted — leave the calendar empty */
      })
    return () => ctrl.abort()
  }, [])

  return { events, loaded }
}
